module.exports = __webpack_public_path__ + "img/round-brown-wooden-5-piece-dining-set-in-room-1571463.4c9b700d.jpg";